import { Drawer } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import Save from "../../Assets/images/save.svg";
import Saved from "../../Assets/images/saved.svg";
import Progress from "../Home/Progress";
import Button from "../SelectValue/Button";
import Section from "./Section";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import getServices from "../../Services/get-service";
import swal from "sweetalert";
import BuyUnits from "./Buyunit";
import Loading from "../SelectValue/Loading";
import Constant from "../../Constant";
import ImageSlider from "./ImageSlider";
import Skeleton from "@mui/material/Skeleton";
import { toast } from "react-toastify";
import postService from "../../Services/post-service";
const drawerWidth = 750;

function ProductDetails() {
  const navigate = useNavigate();
  const handleBack = () => navigate(-1);
  const sliderRef = React.useRef(null);
  const [projectDetail, setProjectDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [isBookmarked, setIsBookmarked] = useState(false);

  const handleThumbnailClick = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };
  const [image, setImages] = useState([]);
  const { id, status } = useParams();
  const location = useLocation();
  const stateProject = location.state?.project;

  useEffect(() => {
    getServices.getSavedProduct().then((response) => {
      if (response.data.statusCode === 200) {
        const rawData = response.data.data;
        let allSaved = [];
        if (Array.isArray(rawData)) allSaved = rawData;
        else if (rawData && Array.isArray(rawData.savedProperties)) allSaved = rawData.savedProperties;
        else if (rawData && Array.isArray(rawData.content)) allSaved = rawData.content;
        else if (rawData && Array.isArray(rawData.projects)) allSaved = rawData.projects;
        else if (rawData && Array.isArray(rawData.data)) allSaved = rawData.data;

        const isSaved = allSaved.some(p => String(p.propertyId || p.projectId || p.id || p.property?.id || p.project?.id) === String(id));
        setIsBookmarked(isSaved);
      }
    }).catch(() => {});
  }, [id]);

  useEffect(() => {
    if (stateProject && stateProject.id === parseInt(id)) {
      setProjectDetails({
        ...stateProject,
        projectName: stateProject.title,
        projecLocation: stateProject.locality,
        pricePerUnit: parseInt(stateProject.unitPrice) || 0,
        projectDescription: stateProject.description,
        percentSold: stateProject.percentageSold || 0,
        unitAvailable: stateProject.unitRemaining || 0,
        projectId: stateProject.id,
        projectPriceTotal: parseInt(stateProject.price) || 0,
        unitSold: 0,
        developerName: stateProject.developerName,
        projectDuration: Math.max(
              0,
              Math.ceil(
                (new Date(stateProject.endDate) - new Date(stateProject.startDate)) /
                  (1000 * 60 * 60 * 24)
              )
            ),
        projectType: stateProject.propertyType,
        videoUrl: stateProject.videoLink,
        investmentDuration: stateProject.noOFDays,
        startDate: stateProject.startDate,
        percentageSold: stateProject.percentageSold,
        targetAmount: stateProject.price,
        amountRaised: stateProject.amountRaised,
      });
      setImages(stateProject.propertyImages?.map((img) => img.imageUrl) || []);
      setLoading(false);
      return;
    }

    setLoading(true);
    getServices.userGetProperty().then(
      (response) => {
        setLoading(false);
        if (response.data.statusCode === 200) {
          const found = response.data.data.find((p) => p.id === parseInt(id));
          if (found) {
            setProjectDetails({
              ...found,
              projectName: found.title,
              projecLocation: found.locality,
              pricePerUnit: parseInt(found.unitPrice) || 0,
              projectDescription: found.description,
              percentSold: found.percentageSold || 0,
              unitAvailable: found.unitRemaining || 0,
              projectId: found.id,
              projectPriceTotal: parseInt(found.price) || 0,
              unitSold: 0,
              developerName: found.developerName,
              projectDuration:
                found.startDate && found.endDate
                  ? Math.max(
                    0,
                    Math.ceil(
                      (new Date(found.endDate) - new Date(found.startDate)) /
                      (1000 * 60 * 60 * 24),
                    ),
                  )
                  : 0,
              projectType: found.propertyType,
              videoUrl: found.videoLink,
              startDate: found.startDate,
              endDate: found.endDate,
              percentageSold: found.percentageSold,
              targetAmount: found.price,
              amountRaised: found.amountRaised,
            });
            setImages(found.propertyImages?.map((img) => img.imageUrl) || []);
          } else {
            toast.error(response.data.description);
          }
        }
      },
      (error) => {
        setLoading(false);
      },
    );
  }, [id, stateProject]);
  const videoId = Constant.getYouTubeVideoId(projectDetail.videoLink ?? "");
  return (
    <div>
      <Outlet />
      <BuyUnits
        open={open}
        handleClose={handleClose}
        number={projectDetail.unitAvailable}
        amount={projectDetail.pricePerUnit}
        id={projectDetail.projectId}
      />
      <Drawer
        anchor="right"
        variant="temporary"
        open={true}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: { xs: "100%", md: drawerWidth },
            backgroundColor: "white",
          },
        }}
      >
        <div>
          <div className=" p-4 border-b border-b-[#808285] flex justify-between">
            <div className=" flex gap-5">
              <div className=" pt-3">
                <KeyboardBackspaceIcon
                  onClick={handleBack}
                  className=" cursor-pointer"
                />
              </div>

              <p className=" text-back-color2 text-[18px] pt-3">
                Project details
              </p>
            </div>

            <div className="pt-2">
              <CancelIcon
                onClick={handleBack}
                className=" text-back-color2 cursor-pointer text-[38px]"
                fontSize="large"
              />
            </div>
          </div>
        </div>
        <div className="p-4 gap-3  grid md:grid-cols-2 mt-3">
          {loading ? (
            <>
              <div className="mt-2">
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={300}
                  sx={{ borderRadius: 2 }}
                />
                <div className="mt-3 grid grid-cols-4 gap-4">
                  {[1, 2, 3, 4].map((item) => (
                    <Skeleton
                      key={item}
                      variant="rectangular"
                      height={60}
                      sx={{ borderRadius: 2 }}
                    />
                  ))}
                </div>
              </div>
              <div className="px-2">
                <div className="flex justify-between mb-1">
                  <Skeleton variant="text" width="60%" height={30} />
                  <Skeleton variant="circular" width={24} height={24} />
                </div>
                <div className="mb-3 flex items-center gap-1">
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width="40%" height={24} />
                </div>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={50}
                  sx={{ borderRadius: 4, mb: 3 }}
                />
                <div className="flex gap-3 mb-3">
                  <Skeleton
                    variant="rectangular"
                    width={100}
                    height={40}
                    sx={{ borderRadius: 4 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={100}
                    height={40}
                    sx={{ borderRadius: 4 }}
                  />
                </div>
                <Skeleton
                  variant="text"
                  width="30%"
                  height={24}
                  sx={{ mb: 3 }}
                />
                <div>
                  <Skeleton
                    variant="text"
                    width="20%"
                    height={20}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={10}
                    sx={{ borderRadius: 1, mb: 2 }}
                  />
                  <div className="flex justify-between mb-2">
                    <Skeleton variant="text" width="30%" height={20} />
                    <Skeleton variant="text" width="30%" height={20} />
                  </div>
                </div>
                <div className="grid grid-cols-1 mt-4">
                  <Skeleton
                    variant="rectangular"
                    height={50}
                    sx={{ borderRadius: 2 }}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className=" mt-2">
                {/* {projectDetail.projectId} */}
                <ImageSlider ref={sliderRef} imageList={image} />
                <div className="mt-3 grid grid-cols-4 gap-4">
                  {projectDetail.propertyImages?.map((img, index) => (
                    <div
                      key={index}
                      onClick={() => handleThumbnailClick(index)}
                      className="cursor-pointer border border-gray-200 rounded-lg overflow-hidden hover:border-primary-color transition-colors"
                    >
                      <img
                        src={img.imageUrl}
                        alt={img.imageTitle}
                        className="w-full h-16 object-cover"
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className=" px-2">
                <div className=" flex justify-between  mb-1">
                  <p className=" text-back-color2 font-[500] capitalize text-[16px] ">
                    {projectDetail.projectName}
                  </p>
                  <div
                    className=" pt-1 cursor-pointer flex items-center gap-1"
                    onClick={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      if (isBookmarked) {
                        postService.removePropertyBuyLater(id).then(
                          (response) => {
                            setLoading(false);
                            if (response.data.statusCode === 200) {
                              setIsBookmarked(false);
                              toast.success("Property removed from saved", { autoClose: 1000 });
                            } else {
                              toast.error(response.data.description, { autoClose: 1000 });
                            }
                          },
                          (error) => {
                            toast.error(error?.response?.data?.description, { autoClose: 1000 });
                            setLoading(false);
                          }
                        );
                      } else {
                        postService.saveProduct(id, "INVESTMENT").then(
                          (response) => {
                            setLoading(false);
                            if (response.data.statusCode === 200) {
                              setIsBookmarked(true);
                              toast.success(response.data.description || "Property saved for later", { autoClose: 1000 });
                            } else {
                              toast.error(response.data.description, { autoClose: 1000 });
                            }
                          },
                          (error) => {
                            toast.error(error?.response?.data?.description, { autoClose: 1000 });
                            setLoading(false);
                          },
                        );
                      }
                    }}
                  >
                    <img src={isBookmarked ? Saved : Save} className="w-5 h-5" alt="save" />
                    <span className=" text-back-color2 text-[14px] font-[500]">
                      {isBookmarked ? "Saved" : "Save"}
                    </span>
                  </div>
                </div>
                <div className=" mb-3">
                  <PlaceOutlinedIcon
                    fontSize="small"
                    className=" text-primary-color"
                  />
                  <p className=" text-[#44474E] text-[14px] capitalize inline-block pl-1">
                    {projectDetail.projecLocation}
                  </p>
                </div>
                <p className=" rounded-[32px] bg-[#F5F7FA] text-[16px] p-3 text-[#1E222B] mb-3">
                  Investment time period : {projectDetail.projectDuration} days
                </p>
                <div className=" flex gap-3">
                  <p className=" rounded-[32px] text-xs bg-[#CCF2E1] p-3 text-[#1E222B] mb-3">
                    NGN {Constant.FormatNumber(projectDetail.pricePerUnit)}{" "}
                  </p>
                  <p className=" rounded-[32px] text-xs bg-[#FFDEDE] p-3 text-[#1E222B] mb-3">
                    {projectDetail.unitRemaining} Units remaining
                  </p>
                </div>
                <p className="text-[#1E222B] mb-3 capitalize font-[500]">
                  By: {projectDetail.developerName}
                </p>
                <div>
                  <p className=" text-[14px] pb-2">
                    {projectDetail.percentageSold || 0}% sold
                  </p>
                  <Progress value={projectDetail.percentageSold || 0} />
                  <div className=" mb-4 flex justify-between">
                    <p className="text-primary-color6 text-[14px]">Target</p>
                    <p className="text-primary-color6 text-[14px]">Raised</p>
                  </div>
                  <div className=" mb-2 flex justify-between">
                    <p className=" text-[14px]">
                      NGN{" "}
                      {Constant.FormatNumber(
                        projectDetail.price || 0,
                      )}
                    </p>
                    <p className="text-[14px] text-primary-color">
                      NGN{" "}
                      {Constant.FormatNumber(projectDetail.amountRaised)}
                    </p>
                  </div>
                </div>
                {projectDetail.unitAvailable === 0 ? (
                  <div className=" grid grid-cols-1">
                    <div className=" p-3 text-[#b00020] bg-[#efccd2] text-center rounded-lg">
                      Sold out
                    </div>
                  </div>
                ) : (
                  <div className=" grid grid-cols-1">
                    <Button name="Buy units" onClick={handleOpen} />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <div className=" p-2 ">
          <Section
            date={Constant.FormatDate(projectDetail.startDate)}
            cArea={projectDetail.coveredAreas || "0sqr"}
            des={projectDetail.projectDescription}
            refs={projectDetail.id}
            statuss="Available"
            type={projectDetail.propertyType}
            videolink={projectDetail.videoLink}
            tA={projectDetail.totalAreas || "0sqr"}
          />
        </div>
      </Drawer>
    </div>
  );
}

export default ProductDetails;
